// Admin API client — server-side session cookies + CSRF double-submit.
// No tokens are stored in localStorage; the CSRF token lives in memory only.
const BASE = process.env.REACT_APP_BACKEND_URL;

let _csrf = null;
export const setCsrf = (t) => {
  _csrf = t || null;
};
export const getCsrf = () => _csrf;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Der opstod en fejl. Prøv igen.";
  if (typeof detail === "string") return DETAIL_DA[detail] || detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const DETAIL_DA = {
  invalid_credentials: "Forkert e-mail eller adgangskode.",
  too_many_attempts: "For mange forsøg. Prøv igen om lidt.",
  not_authenticated: "Du er ikke logget ind.",
  session_expired: "Din session er udløbet. Log ind igen.",
  forbidden: "Du har ikke adgang til dette.",
  csrf_failed: "Sikkerhedskontrol fejlede. Genindlæs siden.",
  wrong_current_password: "Nuværende adgangskode er forkert.",
  user_exists: "Der findes allerede en bruger med denne e-mail.",
  cannot_disable_self: "Du kan ikke deaktivere din egen konto.",
  must_change_password: "Du skal skifte adgangskode først.",
};

async function request(path, { method = "GET", body, csrf = false } = {}) {
  const headers = {};
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (csrf && _csrf) headers["X-CSRF-Token"] = _csrf;
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    credentials: "include",
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return null;
  const ct = res.headers.get("content-type") || "";
  const data = ct.includes("application/json") ? await res.json() : await res.text();
  if (!res.ok) {
    const err = new Error("api_error");
    err.status = res.status;
    err.detail = data && data.detail !== undefined ? data.detail : data;
    throw err;
  }
  return data;
}

export const api = {
  login: (email, password) =>
    request("/auth/login", { method: "POST", body: { email, password } }),
  logout: () => request("/auth/logout", { method: "POST", csrf: true }),
  me: () => request("/auth/me"),
  changePassword: (current_password, new_password) =>
    request("/auth/change-password", {
      method: "POST",
      body: { current_password, new_password },
      csrf: true,
    }),
  dashboard: () => request("/admin/dashboard"),
  messages: (params = {}) => {
    const q = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    ).toString();
    return request(`/admin/messages${q ? `?${q}` : ""}`);
  },
  message: (id) => request(`/admin/messages/${id}`),
  patchMessage: (id, patch) =>
    request(`/admin/messages/${id}`, { method: "PATCH", body: patch, csrf: true }),
  users: () => request("/admin/users"),
  createUser: (payload) =>
    request("/admin/users", { method: "POST", body: payload, csrf: true }),
  setUserActive: (id, active) =>
    request(`/admin/users/${id}?active=${active}`, { method: "PATCH", csrf: true }),
  auditLog: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return request(`/admin/audit-log${q ? `?${q}` : ""}`);
  },
  exportUrl: () => `${BASE}/api/admin/export`,
};
